module.exports = __webpack_public_path__ + "img/甄利凯.aca305d9.jpg";